module.exports = __webpack_public_path__ + "static/img/t-main-footer__logo.56fc6ee8.svg";